module.exports = __webpack_public_path__ + "img/five5Orange.596a2c08.jpg";